import React from 'react';
import { Confirm } from 'semantic-ui-react';
import styles from './confirmAction.scss';

interface IConfirmActionProps {
  open: boolean;
  basic: boolean;
  className?: string;
  content?: string;
  header?: React.ReactNode;
  cancelText?: string;
  confirmText?: string;
  closeOnDimmerClick?: boolean;
  onCancel?: () => void;
  onConfirm: () => void;
  hideCancel?: boolean;
}

const ConfirmAction = ({
  basic,
  className,
  open,
  header,
  content,
  cancelText = 'No',
  confirmText = 'Yes',
  closeOnDimmerClick,
  onCancel,
  onConfirm,
  hideCancel,
}: IConfirmActionProps) => {
  return (
    <Confirm
      className={classnames(
        styles.confirmAction,
        basic && styles.basic,
        hideCancel && styles.hideCancel,
        className,
      )}
      open={open}
      header={header}
      content={content}
      onConfirm={onConfirm}
      confirmButton={confirmText}
      closeOnDimmerClick={closeOnDimmerClick}
      onCancel={onCancel}
      cancelButton={cancelText}
    />
  );
};

export default ConfirmAction;
